import App from './App.svelte';

const app = new App({
	target: document.body,
	props: {
		name: 'world'
	}
});

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
console.log('main.js', window.location.pathname, urlParams.get('a'))

export default app;